import { v4 as uuidv4 } from 'uuid';
import { FlexLayoutCol, FlexLayoutRow } from '../../../../vtex-apps/flex-layout/FlexLayout/default';
import { RichText } from '../../../../vtex-apps/rich-text/RichText/default';
import { Video } from '../../../../vtex-apps/Video/default';
import { VisibilityLayout } from '../../../../vtex-apps/VisibilityLayout/default';
import { Image } from '../../../../vtex-apps/store-components/Image/default';

export default function RichTextVideo() {
	return {
		componentName: 'FlexLayoutRow',
		componentId: uuidv4(),
		componentGroup: 'RichTextVideo',
		props: FlexLayoutRow({
			blockClass: 'flex-row__rtv-3',
			mzTitle: 'MZ | Video SEO',
			colGap: { desktop: 4, tablet: 4, phone: 4 },
		}).props,
		variables,
		childrenComponents: [
			FlexLayoutCol({ blockClass: 'flex-col__rtv-3' }, [
				RichText({
					text: '## Texto SEO categoria',
					blockClass: 'richtext-title__rtv-3',
				}),
				RichText({
					text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Consequat aliquam nunc non amet eget nunc dolor neque. Viverra massa netus cras fringilla nec elementum. Aenean leo malesuada cras integer eget quis. Laoreet non praesent nisl sociis. Scelerisque ipsum at enim, faucibus interdum. Vestibulum tellus vehicula malesuada orci, consequat. Donec orci tempus sagittis facilisis enim, aenean donec ac. \n ##### Subtítulo SEO \n Lorem ipsum dolor sit amet, consectetur adipiscing elit. Consequat aliquam nunc non amet eget nunc dolor neque. Viverra massa netus cras fringilla nec elementum. Aenean leo malesuada cras integer eget quis.\n Laoreet non praesent nisl sociis. Scelerisque ipsum at enim, faucibus interdum. Vestibulum tellus vehicula malesuada orci, consequat. Donec orci tempus sagittis facilisis enim, aenean donec ac. \n Laoreet non praesent nisl sociis. Scelerisque ipsum at enim, faucibus interdum. Vestibulum tellus vehicula malesuada orci, consequat. Donec orci tempus sagittis facilisis enim, aenean donec ac.',
					blockClass: 'richtext-text__rtv-3',
				}),
			]),
			FlexLayoutCol({ blockClass: 'flex-col__rtv-3-right', width: { desktop: 'grow', mobile: '100%' } }, [
				VisibilityLayout({ mzTitle: 'MZ | Vídeo (On/Off))' }, [
					Video({
						blockClass: 'video__rtv-3',
					}),
				]),
				VisibilityLayout({ mzTitle: 'MZ | Imagem (On/Off))', visible: false }, [
					Image({
						blockClass: 'image__rtv-3',
						src: 'https://hefesto-upload-images.s3.amazonaws.com/1683060245014-Slider-Banner-Mobile.png',
					}),
				]),
			]),
		],
	};
}

//one color variable for flexrow bg
//two color variables for richtext colors
//one variable for font family for richtexts
const variables = [
	{
		type: 'color',
		list: [
			{ from: '--transparent', to: '--rtv-3-bg-color', name: 'Background' },
			{ from: '--text-color-1', to: '--rtv-3-title-color', name: 'Title' },
			{ from: '--text-color-1', to: '--rtv-3-text-color', name: 'Body' },
		],
	},
	{
		type: 'fontWeight',
		list: [{ from: '--font-weight-700', to: '--rtv-3-title-fw', name: 'Title' }],
	},
	{
		type: 'fontSize',
		list: [
			{ from: '--font-size-xxxl', to: '--rtv-3-title-fs', name: 'Title Desktop' },
			{ from: '--font-size-sm', to: '--rtv-3-body-fs', name: 'Body Desktop' },
			{ from: '--font-size-xxl', to: '--rtv-3-title-fs-mobile', name: 'Title Mobile' },
			{ from: '--font-size-xs', to: '--rtv-3-body-fs-mobile', name: 'Body Mobile' },
		],
	},
	{
		type: 'typography',
		list: [
			{ from: '--main-font', to: '--rtv-3-title-ff', name: 'Heading' },
			{ from: '--main-font', to: '--rtv-3-body-ff', name: 'Body' },
		],
	},
];
